import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

const StyledMobileNavLink = styled(NavLink)`
  width: 100%;
  padding: 8px 16px;
  color: #484848;
  text-decoration: none;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
  word-break: break-word;
`;

export default StyledMobileNavLink;
